import { html, body } from '../common';

const toplayer = () => {
	const toplayerTemplateYT = (videoID, autoplay = 0) => `<div class="toplayer toplayer--youtube">
	<span class="toplayer__close"></span>
	<div class="toplayer__inner">
		<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoID}?autoplay=${autoplay}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	</div>
	</div>`;

	const toplayerTemplateImage = (href, caption) => `<div class="toplayer toplayer--image">
	<span class="toplayer__close"></span>
	<figure class="toplayer__inner">
		<img src="${href}" alt="${caption}" />
		<figcaption>${caption}</figcaption>
	</figure>
	</div>`;

	const closeToplayer = (remove) => {
		document.querySelectorAll('.toplayer').forEach((layer) => {
			const close = layer.querySelector('.toplayer__close');
			close.addEventListener('click', () => {
				html.classList.remove('toplayer--is-active');
				layer.classList.remove('is-active');
				if (remove) {
					layer.remove();
				}
			});
		});

		document.addEventListener('keydown', (event) => {
			if (document.querySelector('.toplayer.is-active')) {
				const activeLayer = document.querySelector('.toplayer.is-active');
				if (event.key === 'Escape') {
					html.classList.remove('toplayer--is-active');
					if (activeLayer.classList.contains('toplayer--youtube')) {
						activeLayer.classList.remove('is-active');
						activeLayer.remove();
					} else {
						activeLayer.classList.remove('is-active');
					}
				}
			}
		});
	};

	// person toplayer
	if (document.querySelectorAll('[data-js-person]').length > 0) {
		document.querySelectorAll('[data-js-person]').forEach((person) => {
			const pp = person.getAttribute('data-js-person');
			person.addEventListener('click', (event) => {
				event.preventDefault();
				if (document.getElementById(`person-${pp}`)) {
					html.classList.add('toplayer--is-active');
					document.getElementById(`person-${pp}`).classList.add('is-active');
				}
			});
		});
	}

	// youtube toplayer
	if (document.querySelectorAll('[data-video]').length > 0) {
		document.querySelectorAll('[data-video]').forEach((video) => {
			const videoID = video.getAttribute('data-video');
			const autoplay = video.getAttribute('data-video-autoplay');
			video.addEventListener('click', (event) => {
				event.preventDefault();
				body.insertAdjacentHTML('beforeend', toplayerTemplateYT(videoID, autoplay));
				setTimeout(() => {
					html.classList.add('toplayer--is-active');
					document.querySelector('.toplayer--youtube').classList.add('is-active');
				}, 300);

				closeToplayer(true);
			});
		});
	}

	// image toplayer
	if (document.querySelectorAll('[data-image]').length > 0) {
		document.querySelectorAll('[data-image]').forEach((image) => {
			const imageHref = image.getAttribute('href');
			const caption = image.getAttribute('data-caption');
			image.addEventListener('click', (event) => {
				event.preventDefault();
				body.insertAdjacentHTML('beforeend', toplayerTemplateImage(imageHref, caption));
				setTimeout(() => {
					html.classList.add('toplayer--is-active');
					document.querySelector('.toplayer--image').classList.add('is-active');
				}, 300);

				closeToplayer(true);
			});
		});
	}

	if (document.querySelectorAll('[data-js-person]').length > 0) {
		closeToplayer();
	}
};

export default toplayer;
